var _effectorFileName = "/builds/gmini/front-ui-kit/src/OfflineModal/OfflineModal.tsx";
import * as React from 'react';
import { Button } from '@mui/material';
import { Dialog } from '../Dialog';
import { DialogContent } from '../DialogContent';
import { DialogContentText } from '../DialogContentText';
import { DialogActions } from '../DialogActions';
import { DialogTitle } from '../DialogTitle';
import { useConnectionBroken } from './model';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OfflineModal = /*#__PURE__*/React.memo(() => {
  const connectionBroken = useConnectionBroken();
  return /*#__PURE__*/_jsxs(Dialog, {
    open: connectionBroken,
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      children: "\u041F\u043E\u0442\u0435\u0440\u044F \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F"
    }), /*#__PURE__*/_jsx(DialogContent, {
      children: /*#__PURE__*/_jsx(DialogContentText, {
        children: "\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0441 \u0441\u0435\u0440\u0432\u0435\u0440\u043E\u043C \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443."
      })
    }), /*#__PURE__*/_jsx(DialogActions, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: reload,
        children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"
      })
    })]
  });
});
OfflineModal.displayName = 'OfflineModal';

const reload = () => window.location.reload();